'use client';

import React, { useEffect, useRef, useState } from 'react';

import { calculateSatisfaction } from '@/utilities/calculateSatisfaction';

import { STATS } from '@/constants/downloadApp';

import classes from '../../index.module.css';
import { useCountUp, useRevealGroup } from '../hooks';
import { StatItemProps } from './models';

const StatItem = ({ value, decimals = 0, suffix, label, started, delay }: StatItemProps) => {
    const display = useCountUp(value, started, 1600, decimals);

    return (
        <li
            data-reveal
            className={`${classes.revealPop} flex flex-col items-center gap-1 rounded-lg px-4 py-6 text-center`}
            style={{ '--reveal-delay': `${delay}ms` } as React.CSSProperties}>
            <span
                className={`text-3xl font-black md:text-4xl
                    ${label.includes('امتیاز') ? calculateSatisfaction(value, 1).fillClassName : 'text-white'}`}
                dir='rtl'>
                {display}
                {suffix && <span className='text-lg font-bold text-whiteMediumEmphasis md:text-xl'>{suffix}</span>}
            </span>
            <span className='text-xs text-whiteMediumEmphasis md:text-sm'>{label}</span>
        </li>
    );
};

const Stats = () => {
    const [started, setStarted] = useState(false);
    const ref = useRef<HTMLDivElement | null>(null);
    const groupRef = useRevealGroup<HTMLElement>(classes.revealVisible);

    useEffect(() => {
        const el = ref.current;
        if (!el) return;
        if (!('IntersectionObserver' in window)) {
            setStarted(true);
            return;
        }
        const observer = new IntersectionObserver(
            (entries) => {
                if (entries.some((entry) => entry.isIntersecting)) {
                    setStarted(true);
                    observer.disconnect();
                }
            },
            { threshold: 0.35 }
        );
        observer.observe(el);
        return () => observer.disconnect();
    }, []);

    return (
        <section ref={groupRef} className='desktop-width relative z-10 -mt-5 mb-5 px-4 md:px-8' aria-label='آمار اپلیکیشن ازکی‌سرویس'>
            <div ref={ref} className={`${classes.glassDark} rounded-lg px-4 py-4 shadow-elevation2 md:px-8 md:py-6`}>
                <ul className='m-0 grid list-none grid-cols-1 gap-2 p-0 sm:grid-cols-3'>
                    {STATS.map((stat, idx) => (
                        <StatItem key={stat.id} {...stat} started={started} delay={idx * 90} />
                    ))}
                </ul>
            </div>
        </section>
    );
};

export default Stats;
